/**
 * Abschnitt Lieferanten — products.suppliers (JSONB), 1:1 aus dem alten Modal.
 * Wird nur geschrieben, wenn sich tatsächlich etwas geändert hat.
 */
import { Plus, Trash2, Truck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { newSupplierKey } from '@/lib/productEditorModel';
import { Section, Field, NumInput, TextInput } from './EditorPrimitives';

const EMPTY = { name: '', price: '', delivery_time: '', artikelnummer: '' };

export default function ProductEditorLieferanten({ suppliers, onChange, supplierList }) {
  const names = supplierList.filter((s) => s.is_active !== false).map((s) => s.name).sort();
  const update = (i, key, val) => onChange(suppliers.map((s, k) => (k === i ? { ...s, [key]: val } : s)));
  const remove = (i) => onChange(suppliers.filter((_, k) => k !== i));

  return (
    <Section icon={Truck} title={`Lieferanten${suppliers.length ? ` (${suppliers.length})` : ''}`}
      hint="Einkaufspreise, Lieferzeiten und Lieferanten-Artikelnummern."
      action={(
        <Button type="button" variant="outline" size="sm" onClick={() => onChange([...suppliers, { ...EMPTY, _key: newSupplierKey() }])} className="h-9 gap-1.5 shrink-0">
          <Plus className="w-3.5 h-3.5" /> Lieferant
        </Button>
      )}>
      {suppliers.length === 0 ? (
        <p className="text-sm text-slate-400 py-3 text-center rounded-lg border border-dashed border-slate-300">Noch keine Lieferanten hinterlegt.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {suppliers.map((s, i) => {
            const options = s.name && !names.includes(s.name) ? [s.name, ...names] : names;
            return (
              <div key={s._key || `db-${i}`} className="rounded-lg border border-slate-200 bg-white p-3 space-y-3">
                <div className="flex items-end gap-2">
                  <Field label="Lieferant" className="flex-1">
                    <Select value={s.name || ''} onValueChange={(v) => update(i, 'name', v)}>
                      <SelectTrigger className="min-h-[44px]"><SelectValue placeholder="Lieferant wählen…" /></SelectTrigger>
                      <SelectContent>
                        {options.map((n) => <SelectItem key={n} value={n}>{n}</SelectItem>)}
                      </SelectContent>
                    </Select>
                  </Field>
                  <Button type="button" variant="ghost" size="icon" onClick={() => remove(i)} aria-label="Lieferant entfernen"
                    className="h-11 w-11 text-slate-400 hover:text-red-600 hover:bg-red-50 shrink-0">
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <Field label="Preis €">
                    <NumInput value={s.price ?? ''} onChange={(e) => update(i, 'price', e.target.value)} placeholder="0,00" />
                  </Field>
                  <Field label="Lieferzeit">
                    <TextInput value={s.delivery_time || ''} onChange={(e) => update(i, 'delivery_time', e.target.value)} placeholder="z. B. 3–5 Tage" />
                  </Field>
                  <Field label="Lieferanten-Artikelnr." className="col-span-2">
                    <TextInput value={s.artikelnummer || ''} onChange={(e) => update(i, 'artikelnummer', e.target.value)} className="font-mono" placeholder="z. B. LF-12345" />
                  </Field>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Section>
  );
}
